import { Component, OnInit } from '@angular/core';
import {
  DailyMovementLimitResult,
  DailyMovementLimitService,
} from '../../../services/daily-movement-limit.service';
import { UserService } from '../../../services';
import { OrderLimitTypeEnum } from '../../../enums/order-limit-type.enum';

@Component({
  selector: 'order-limits-calendar',
  templateUrl: './order-limits-calendar.component.html',
  styleUrls: ['./order-limits-calendar.component.scss'],
})
export class OrderLimitsCalendarComponent implements OnInit {
  constructor(
    private dailyLimitsService: DailyMovementLimitService,
    private userService: UserService,
  ) {}

  public movementLimits: DailyMovementLimitResult[];

  public drivenLimits: any;
  public drivenDayColors: any;
  public transportLimits: any;
  public transportDayColors: any;

  ngOnInit() {
    this.userService.getCurrentUserOrg().then((res) => {
      // load limits and totals
      this.dailyLimitsService.getDailyMovementLimits(res.id).then((res) => {
        this.movementLimits = res;

        this.drivenLimits = this.processMovementLimits(res, OrderLimitTypeEnum.Driven);
        this.drivenDayColors = this.dailyLimitsService.getDayColors(
          this.movementLimits,
          OrderLimitTypeEnum.Driven,
          true,
        );

        this.transportLimits = this.processMovementLimits(res, OrderLimitTypeEnum.Transported);
        this.transportDayColors = this.dailyLimitsService.getDayColors(
          this.movementLimits,
          OrderLimitTypeEnum.Transported,
          true,
        );
      });
    });
  }

  processMovementLimits(res: DailyMovementLimitResult[], type: OrderLimitTypeEnum) {
    const result = res.map((r: DailyMovementLimitResult) => {
      let isLimitReached = false;
      if (type === OrderLimitTypeEnum.Driven) {
        isLimitReached =
          (r.global.drivenLimit && r.global.drivenTotal >= r.global.drivenLimit) ||
          (r.customer.drivenLimit && r.customer.drivenTotal >= r.customer.drivenLimit);
      } else if (type === OrderLimitTypeEnum.Transported) {
        isLimitReached =
          (r.global.transportedLimit && r.global.transportedTotal >= r.global.transportedLimit) ||
          (r.customer.transportedLimit &&
            r.customer.transportedTotal >= r.customer.transportedLimit);
      }

      // if limit is reached, display that this day is fully booked
      if (isLimitReached) {
        return {
          start: r.date,
          end: r.date,
          resourceEditable: false,
          display: 'block',
          title: 'Unavailable',
          description:
            type === OrderLimitTypeEnum.Driven
              ? 'Fully booked for driven moves'
              : 'Fully booked for transported moves',
        };
      }
    });

    return result.filter((r) => !!r);
  }
}
